import { Injectable } from "@angular/core";
import { AsyncScriptLoaderService } from '@modules/common/services/async-script-loader.service';
import { Observable, ReplaySubject } from "rxjs";

const AG_GRID_CSS_URL = 'https://media.winstonfinancial.com/Stingray/ag-grid/17.1.1/ag-grid.css';
const AG_GRID_CSS_THEME_URL = 'https://media.winstonfinancial.com/Stingray/ag-grid/17.1.1/ag-theme-balham.css';
const AG_GRID_URL = 'https://media.winstonfinancial.com/Stingray/ag-grid/17.1.1/ag-grid-enterprise.min.noStyle.js';

/**
 * Service to load the ag-grid Library
 */
@Injectable({
    providedIn: 'root'
})
export class AGGridLoaderService {
    constructor(
        private _asyncScriptLoaderService: AsyncScriptLoaderService
    ) { }

    private static _subject?: ReplaySubject<any>;

    /**
     * Load the ag-grid library and return an observable that fires
     * when the library has finished loading.
     */
    public loadAGGrid(): Observable<any> {
        if (!AGGridLoaderService._subject) {
            AGGridLoaderService._subject = new ReplaySubject(1);

            document.head.appendChild(this.createCSSElement(AG_GRID_CSS_URL));
            document.head.appendChild(this.createCSSElement(AG_GRID_CSS_THEME_URL));

            this._asyncScriptLoaderService.loadScriptAsync({
                id: 'aggrid-script-tag',
                url: AG_GRID_URL
            }).subscribe(() => AGGridLoaderService._subject && AGGridLoaderService._subject.next(true));
        }

        return AGGridLoaderService._subject;
    }

    private createCSSElement(url: string): HTMLLinkElement {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = url;
        return link;
    }
}
